export default function PlusIcon(){
    return(<svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10.4993 4.16699V15.8337M4.66602 10.0003H16.3327" stroke="white" strokeWidth="1.67" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
   )
}